// src/components/settings/shared/SettingsModal.jsx - FIXED WITH PROPER SCROLLING
import React from 'react';
import { X, Save, Loader2 } from 'lucide-react';

export const SettingsModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  title, 
  saving = false, 
  hasChanges = false,
  headerColor = '#3b82f6',
  headerIcon: HeaderIcon,
  children 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-7xl max-h-[95vh] flex flex-col">
        {/* Header with Save Button */}
        <div 
          className="flex items-center justify-between p-6 text-white rounded-t-xl shrink-0"
          style={{ backgroundColor: headerColor }}
        >
          <div className="flex items-center gap-3">
            {HeaderIcon && <HeaderIcon className="h-6 w-6" />}
            <div>
              <h2 className="text-xl font-semibold">{title}</h2>
              <p className="text-white/80 text-sm">
                Configure settings and preferences
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            {/* Save Button in Header */}
            <button
              onClick={onSave}
              disabled={saving || !hasChanges}
              className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50"
            >
              {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
              {saving ? 'Saving...' : 'Save Settings'}
            </button>
            
            {/* Close Button */}
            <button
              onClick={onClose}
              className="p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* Content Area - Scrollable with proper height */}
        <div className="flex flex-1 overflow-hidden min-h-0">
          {children}
        </div>

        {/* Optional Status Bar */}
        {hasChanges && (
          <div className="px-6 py-2 bg-yellow-50 border-t border-yellow-200 text-yellow-800 text-sm shrink-0">
            ⚠️ You have unsaved changes
          </div>
        )}
      </div>
    </div>
  );
};